/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Base,
    BaseFromJSON,
    BaseFromJSONTyped,
    BaseToJSON,
} from './';

/**
 * 
 * @export
 * @interface Attachment
 */
export interface Attachment {
    /**
     * When was the entity created
     * @type {Date}
     * @memberof Attachment
     */
    createdAt: Date;
    /**
     * When was the entity updated
     * @type {Date}
     * @memberof Attachment
     */
    updatedAt: Date;
    /**
     * Size of the file in bytes
     * @type {number}
     * @memberof Attachment
     */
    fileSize: number;
    /**
     * 
     * @type {string}
     * @memberof Attachment
     */
    id: string;
    /**
     * Name of the attachment (as default incl. file extension)
     * @type {string}
     * @memberof Attachment
     */
    name: string;
    /**
     * ID of company owning the attachment
     * @type {string}
     * @memberof Attachment
     */
    ownerId: string;
}

export function AttachmentFromJSON(json: any): Attachment {
    return AttachmentFromJSONTyped(json, false);
}

export function AttachmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): Attachment {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'createdAt': (new Date(json['created_at'])),
        'updatedAt': (new Date(json['updated_at'])),
        'fileSize': json['file_size'],
        'id': json['id'],
        'name': json['name'],
        'ownerId': json['owner_id'],
    };
}

export function AttachmentToJSON(value?: Attachment | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'created_at': (value.createdAt.toISOString()),
        'updated_at': (value.updatedAt.toISOString()),
        'file_size': value.fileSize,
        'id': value.id,
        'name': value.name,
        'owner_id': value.ownerId,
    };
}


